import React, { useState, useEffect, useLayoutEffect } from "react";
import Layout from "Components/Layout";
import TutorClasses from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";

import { useNavigate } from "react-router-dom";
import { Services } from "Services";
import { useSearchParams } from "react-router-dom";
import ReactLoading from "react-loading";

import MainLoader from "Components/loader/loader";
import { SuccessSwal, warningSwal } from "Util/Toast";
import { compareObjects, CheckIsObjectEmpty } from "Util/Util";
import { useLocation } from "react-router-dom";

window.Buffer = window.Buffer || require("buffer").Buffer;
function Addcategory() {
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [Roles, setRoles] = useState([]);
    const [params] = useSearchParams();
    const [edit, setEdit] = useState(false);
    const [mainLoad, setMainLoad] = useState(false);
    const Navigate = useNavigate();

    const {
        register,
        handleSubmit,
        reset,

        formState: { errors },
    } = useForm();
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    useEffect(() => {
        Services.getRoles("GET", null, token)
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setRoles(response.JobRoles);
                    if (params.get("id")) {
                        setEdit(true);
                        reset({
                            RoleID: location.state?.RoleID || "",
                            Experience: location.state?.Experience || "",
                            Address: location.state?.Address || "",
                            Status: location.state?.Status || 1,
                        });
                    }
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });

        // eslint-disable-next-line
    }, []);

    const onSubmit = (data) => {
        // setLoading(true);
        console.log("22423");
        if (edit) {
            let body = compareObjects(data, {
                RoleID: location.state?.RoleID || "",
                Experience: location.state?.Experience || "",
                Address: location.state?.Address || "",
                Status: location.state?.Status || 1,
            });

            if (!CheckIsObjectEmpty(body)) {
                Services.updateJobOpenings(
                    "PUT",
                    JSON.stringify(data),
                    token,
                    params.get("id")
                )
                    .then((response) => {
                        if (response.Status === 1) {
                            SuccessSwal("Category Updated", response.Message);
                            Navigate(-1);
                        } else if (response.Status === 0) {
                            setLoading(false);
                            warningSwal("Warning", response.Message);
                        }
                    })
                    .catch((err) => {
                        // alert(err);
                        setLoading(false);
                        alert("something went wrong please try again");
                        console.log(err);
                    });
            } else {
                warningSwal("Warning", "Nothing to update");
            }
        } else {
            Services.addJobOpenings("POST", JSON.stringify(data), token)
                .then((response) => {
                    if (response.Status === 1) {
                        Navigate(-1);
                        SuccessSwal("Category Added", response.Message);
                    } else if (response.Status === 0) {
                        setLoading(false);
                        warningSwal("Warning", response.Message);
                    }
                })
                .catch((err) => {
                    // alert(err);
                    setLoading(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };

    const backButton = () => {
        Navigate(-1);
    };

    return (
        <Layout Active={"Openings"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{edit ? "Update" : "Add"} Job Opening</title>
            </Helmet>
            {mainLoad && <MainLoader />}
            <div className={TutorClasses["Container"]}>
                <button onClick={backButton} className={TutorClasses["back"]}>
                    Back
                </button>
                <div className={TutorClasses["wrapper"]}>
                    <h3>{!edit ? "Add Opening" : "Update Opening"}</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {/* <h3>Add Category</h3> */}
                        <div className={TutorClasses["form-control"]}>
                            <label htmlFor="First Name">
                                Role <span className="important">*</span>
                            </label>
                            <select
                                {...register("RoleID", {
                                    required: "this field is required",
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select Role
                                </option>
                                {Roles.map((role) => (
                                    <option value={role.RoleID}>
                                        {role.Role}
                                    </option>
                                ))}
                            </select>
                            {errors.RoleID && (
                                <span>{errors.RoleID.message}</span>
                            )}
                        </div>
                        <div className={TutorClasses["form-control"]}>
                            <label htmlFor="First Name">
                                Experience <span className="important">*</span>
                            </label>
                            <input
                                {...register("Experience", {
                                    required: "this field is required",
                                })}
                            />
                            {errors.Experience && (
                                <span>{errors.Experience.message}</span>
                            )}
                        </div>
                        <div className={TutorClasses["form-control"]}>
                            <label htmlFor="First Name">
                                Location <span className="important">*</span>
                            </label>
                            <input
                                {...register("Address", {
                                    required: "this field is required",
                                })}
                            />
                            {errors.Address && (
                                <span>{errors.Address.message}</span>
                            )}
                        </div>
                        <div className={TutorClasses["form-control"]}>
                            <label htmlFor="First Name">
                                Status <span className="important">*</span>
                            </label>
                            <select
                                {...register("Status", {
                                    required: true,
                                })}>
                                <option value="1">Active</option>
                                <option value="2">Inactive</option>
                            </select>
                            {errors.Status && (
                                <span>This field is required</span>
                            )}
                        </div>

                        <button disabled={loading}>
                            {" "}
                            {loading ? (
                                <ReactLoading
                                    color="green"
                                    type="spokes"
                                    height={30}
                                    width={30}
                                />
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </Layout>
    );
}

export default Addcategory;
